import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { Institution } from "../../API";
import { QueryStatus } from "../../app/types";

interface InstitutionsSlice {
  institutions?: Institution[] | null;
  institutionsStatus: QueryStatus;
  institutionsError?: string;
}

const initialState: InstitutionsSlice = {
  institutions: [],
  institutionsStatus: "idle"
};

export const institutionsSlice = createSlice({
  name: "institutions",
  initialState,
  reducers: {
    setInstitutions: (
      state,
      action: PayloadAction<Institution[] | null | undefined>
    ) => {
      state.institutions = action.payload;
    },
    setInstitutionsStatus: (state, action: PayloadAction<QueryStatus>) => {
      state.institutionsStatus = action.payload;
    },
    setInstitutionsError: (state, action: PayloadAction<string | undefined>) => {
      state.institutionsError = action.payload;
    }
  }
});

export const {
  setInstitutions,
  setInstitutionsStatus,
  setInstitutionsError
} = institutionsSlice.actions;

export const selectInstitutions = (state: RootState) =>
  state.institutions.institutions ?? [];
export const selectInstitutionsStatus = (state: RootState) =>
  state.institutions.institutionsStatus;
export const selectInstitutionsError = (state: RootState) =>
  state.institutions.institutionsError;

export default institutionsSlice.reducer;
